module.exports = __webpack_public_path__ + "static/media/24-4.b17a0f3b.mp3";